"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isJitaUser = exports.initializeIsJitaUser = void 0;

var _BaseContainer = _interopRequireDefault(require("./BaseContainer"));

var CurrentOwnerContainer = _BaseContainer.default.create();

var AuthContainer = _BaseContainer.default.create();

var _initializeIsJitaUser = function initializeIsJitaUser(ownerId, auth) {
  CurrentOwnerContainer.getContainer().set(ownerId);
  AuthContainer.getContainer().set(auth);
};

exports.initializeIsJitaUser = _initializeIsJitaUser;

var isJitaUser = function isJitaUser() {
  var ownerId = CurrentOwnerContainer.getContainer().get();
  var auth = AuthContainer.getContainer().get();
  return ownerId === -1 && auth.user && auth.user.email && auth.user.email.indexOf('@hubspot') > -1;
};

exports.isJitaUser = isJitaUser;

var _default = Object.assign(CurrentOwnerContainer, {
  initializeIsJitaUser: function initializeIsJitaUser(ownerId, auth) {
    return _initializeIsJitaUser(ownerId, auth);
  },

  get isJitaUser() {
    return isJitaUser();
  },

  set isJitaUser(value) {
    throw new Error('isJitaUser is a derived value and not assignable, use initializeIsJitaUser(ownerId, auth) isJitaUser()');
  }

});

exports.default = _default;